/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_BroadcastingInputs */

const th_video_broadcasting = /** @type {(inputs: Video_BroadcastingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังถ่ายทอดสด เปิดหน้ารับชมบนอุปกรณ์อื่นเพื่อดู`)
};

const en_video_broadcasting = /** @type {(inputs: Video_BroadcastingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Broadcasting. Open the Watch page on another device to see it.`)
};

const ja_video_broadcasting = /** @type {(inputs: Video_BroadcastingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配信中です。別の端末で視聴ページを開くと見られます。`)
};

const zh_video_broadcasting = /** @type {(inputs: Video_BroadcastingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在直播。在另一台设备上打开观看页面即可看到。`)
};

const es_video_broadcasting = /** @type {(inputs: Video_BroadcastingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retransmitiendo. Abre la página Ver en otro dispositivo para comprobarlo.`)
};

const pt_video_broadcasting = /** @type {(inputs: Video_BroadcastingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transmitindo. Abra a página Assistir em outro dispositivo para ver.`)
};

const id_video_broadcasting = /** @type {(inputs: Video_BroadcastingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedang menyiarkan. Buka halaman tonton di perangkat lain untuk melihatnya.`)
};

const fr_video_broadcasting = /** @type {(inputs: Video_BroadcastingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diffusion en cours. Ouvrez la page Regarder sur un autre appareil pour la voir.`)
};

const tl_video_broadcasting = /** @type {(inputs: Video_BroadcastingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nagsasahimpapawid. Buksan ang pahina ng panonood sa ibang device para makita ito.`)
};

const vi_video_broadcasting = /** @type {(inputs: Video_BroadcastingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang phát. Mở trang xem trên thiết bị khác để thấy nó.`)
};

const ko_video_broadcasting = /** @type {(inputs: Video_BroadcastingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`중계 중입니다. 다른 기기에서 시청 페이지를 열면 볼 수 있습니다.`)
};

const de_video_broadcasting = /** @type {(inputs: Video_BroadcastingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übertragung läuft. Öffne die Zuschauen-Seite auf einem anderen Gerät, um sie zu sehen.`)
};

const ru_video_broadcasting = /** @type {(inputs: Video_BroadcastingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Идёт трансляция. Откройте страницу просмотра на другом устройстве, чтобы увидеть её.`)
};

const tr_video_broadcasting = /** @type {(inputs: Video_BroadcastingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yayında. Görmek için başka bir cihazda izleme sayfasını açın.`)
};

const it_video_broadcasting = /** @type {(inputs: Video_BroadcastingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trasmissione in corso. Apri la pagina di visione su un altro dispositivo per vederla.`)
};

const pl_video_broadcasting = /** @type {(inputs: Video_BroadcastingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trwa transmisja. Otwórz stronę oglądania na innym urządzeniu, aby ją zobaczyć.`)
};

const uk_video_broadcasting = /** @type {(inputs: Video_BroadcastingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Триває трансляція. Відкрийте сторінку перегляду на іншому пристрої, щоб її побачити.`)
};

const hi_video_broadcasting = /** @type {(inputs: Video_BroadcastingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रसारण चल रहा है। इसे देखने के लिए दूसरे उपकरण पर देखने का पृष्ठ खोलें।`)
};

const ar_video_broadcasting = /** @type {(inputs: Video_BroadcastingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البث جارٍ. افتح صفحة المشاهدة على جهاز آخر لتراه.`)
};

const ms_video_broadcasting = /** @type {(inputs: Video_BroadcastingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedang menyiarkan. Buka halaman tontonan pada peranti lain untuk melihatnya.`)
};

const bn_video_broadcasting = /** @type {(inputs: Video_BroadcastingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সম্প্রচার চলছে। দেখতে অন্য যন্ত্রে দেখার পৃষ্ঠা খুলুন।`)
};

const zh_tw2_video_broadcasting = /** @type {(inputs: Video_BroadcastingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`轉播中。在另一台裝置上開啟觀看頁面即可看到。`)
};

const zh_hk2_video_broadcasting = /** @type {(inputs: Video_BroadcastingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`轉播中。在另一台裝置上開啟觀看頁面即可看到。`)
};

const ur_video_broadcasting = /** @type {(inputs: Video_BroadcastingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نشریات جاری ہیں۔ دیکھنے کے لیے دوسرے آلے پر دیکھنے کا صفحہ کھولیں۔`)
};

const fa_video_broadcasting = /** @type {(inputs: Video_BroadcastingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`در حال پخش. برای دیدنش صفحهٔ تماشا را روی دستگاه دیگری باز کنید.`)
};

const sw_video_broadcasting = /** @type {(inputs: Video_BroadcastingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inarusha. Fungua ukurasa wa kutazama kwenye kifaa kingine ili kuiona.`)
};

const nl_video_broadcasting = /** @type {(inputs: Video_BroadcastingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bezig met uitzenden. Open de kijkpagina op een ander apparaat om het te zien.`)
};

/**
* | output |
* | --- |
* | "Broadcasting. Open the Watch page on another device to see it." |
*
* @param {Video_BroadcastingInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_broadcasting = /** @type {((inputs?: Video_BroadcastingInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_BroadcastingInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_broadcasting(inputs)
	if (locale === "ja") return ja_video_broadcasting(inputs)
	if (locale === "zh") return zh_video_broadcasting(inputs)
	if (locale === "es") return es_video_broadcasting(inputs)
	if (locale === "pt") return pt_video_broadcasting(inputs)
	if (locale === "id") return id_video_broadcasting(inputs)
	if (locale === "fr") return fr_video_broadcasting(inputs)
	if (locale === "tl") return tl_video_broadcasting(inputs)
	if (locale === "vi") return vi_video_broadcasting(inputs)
	if (locale === "ko") return ko_video_broadcasting(inputs)
	if (locale === "de") return de_video_broadcasting(inputs)
	if (locale === "ru") return ru_video_broadcasting(inputs)
	if (locale === "tr") return tr_video_broadcasting(inputs)
	if (locale === "it") return it_video_broadcasting(inputs)
	if (locale === "pl") return pl_video_broadcasting(inputs)
	if (locale === "uk") return uk_video_broadcasting(inputs)
	if (locale === "hi") return hi_video_broadcasting(inputs)
	if (locale === "ar") return ar_video_broadcasting(inputs)
	if (locale === "ms") return ms_video_broadcasting(inputs)
	if (locale === "bn") return bn_video_broadcasting(inputs)
	if (locale === "zh-TW") return zh_tw2_video_broadcasting(inputs)
	if (locale === "zh-HK") return zh_hk2_video_broadcasting(inputs)
	if (locale === "ur") return ur_video_broadcasting(inputs)
	if (locale === "fa") return fa_video_broadcasting(inputs)
	if (locale === "sw") return sw_video_broadcasting(inputs)
	if (locale === "nl") return nl_video_broadcasting(inputs)
	return en_video_broadcasting(inputs)
});